import {createSlice} from "@reduxjs/toolkit";
import {
  setMapFilter,
  setMapFilterEntity,
  setMapFocusPoint,
  setMapOpsMode,
  setMapOpsModeFilter,
  setMapState
} from "./actions";
import {changeRegion, siteTypes} from "@ots-frontend/ots-data";
import {MapFilter, MapFocusPoint, MapOpsModeFilter, MapState} from "@ots-frontend/ots-ui";

type State = {
  mapState?: MapState
  focusPoint?: MapFocusPoint
  filter: MapFilter
  opsMode: boolean
  opsModeFilter?: MapOpsModeFilter
}

const INITIAL_STATE: Readonly<State> = {
  mapState: undefined,
  focusPoint: undefined,
  filter: {
    entity: "TRAILER",
    sites: {
      show: true,
      criteria: {
        state: "all",
        siteTypes: siteTypes
      }
    },
    trailers: {
      show: true,
      criteria: {
        state: "inShift",
        companyId: undefined
      }
    }
  },
  opsMode: false,
  opsModeFilter: undefined,
};

const mapSlice = createSlice({
  name: "map",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setMapState,
      (state, {payload}) => {
        state.mapState = payload;
      }
    );
    builder.addCase(
      setMapFocusPoint,
      (state, {payload}) => {
        state.focusPoint = payload;
      }
    );
    builder.addCase(
      setMapFilter,
      (state, {payload}) => {
        state.filter = payload;
      }
    );
    builder.addCase(
      setMapFilterEntity,
      (state, {payload}) => {
        state.filter.entity = payload;
      }
    );
    builder.addCase(
      setMapOpsMode,
      (state, {payload}) => {
        state.opsMode = payload;
      }
    );
    builder.addCase(
      setMapOpsModeFilter,
      (state, {payload}) => {
        state.opsModeFilter = payload;
      }
    );
    builder.addCase(changeRegion, (_state) => {
      return INITIAL_STATE;
    });
  }
});

export const mapReducer = mapSlice.reducer;
